/**
 * Funnel Registry - Defines event funnels for automatic funnelEntryId tracking
 *
 * When an entry event fires, a new UUID is generated and stored.
 * Subsequent funnel events automatically receive the stored UUID.
 * Re-entering the funnel generates a new UUID.
 */

export interface FunnelDefinition {
  /** Events that start a new funnel (generate new funnelEntryId) */
  entryEvents: string[];
  /** Events within the funnel (receive the active funnelEntryId) */
  funnelEvents: string[];
}

export const funnelRegistry: Record<string, FunnelDefinition> = {
  shift_request: {
    entryEvents: [
      'dental_portal:menu_bar:shift_request_clicked',
      'dental_portal:dashboard:shift_request_clicked',
      'dental_portal:calendar:shift_request_clicked',
      'dental_portal:empty_state:shift_request_clicked',
      'dental_portal:invite:new_invite_clicked',
    ],
    funnelEvents: [
      'dental_portal:shift_request:select_dates_viewed',
      'dental_portal:shift_request:dates_selected',
      'dental_portal:shift_request:shift_details_viewed',
      'dental_portal:shift_request:shift_details_submitted',
      'dental_portal:shift_request:fill_preferences_submitted',
      'dental_portal:shift_request:review_confirm_viewed',
      'dental_portal:shift_request:request_submitted',
      // Both need the entry id to read per visit rather than per office.
      'dental_portal:shift_request:abandoned',
      'dental_portal:shift_request:autoconfirm_toggle_attempted',
      'dental_portal:missing_info_popup:viewed',
      'dental_portal:missing_info_popup:info_submitted',
    ],
  },
};
